import { EnergyEstimate } from "../services/portfolioApi"

type Breakdown = NonNullable<EnergyEstimate["breakdowns"]>[number]

const toCategoryKey = (category?: string) => category || "Unknown"

const capitalise = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1)

const sumByCategory = (
  breakdowns: Breakdown[],
  field: "totalElectricityKwh" | "totalGasKwh"
) =>
  breakdowns.reduce<Record<string, number>>((acc, breakdown) => {
    const category = capitalise(toCategoryKey(breakdown.category))
    const rawValue = breakdown[field]
    const numericValue = rawValue ? parseFloat(rawValue) : 0
    if (numericValue <= 0) return acc
    acc[category] = (acc[category] || 0) + numericValue
    return acc
  }, {})

const toChartData = (categoryTotals: Record<string, number>) =>
  Object.entries(categoryTotals).map(([name, value]) => ({ name, value }))

export const getDefaultEnergyEstimate = (energyEstimates: EnergyEstimate[]) =>
  energyEstimates.find((estimate) => estimate.scenario === "default") ||
  energyEstimates[0] ||
  null

export const getElectricityChartData = (estimate: EnergyEstimate) => {
  const breakdowns = estimate.breakdowns || []
  const categoryTotals = sumByCategory(breakdowns, "totalElectricityKwh")
  return {
    chartData: toChartData(categoryTotals),
    categoryTotals
  }
}

export const getGasChartData = (estimate: EnergyEstimate) => {
  const breakdowns = estimate.breakdowns || []
  const categoryTotals = sumByCategory(breakdowns, "totalGasKwh")
  return {
    chartData: toChartData(categoryTotals),
    categoryTotals
  }
}

export const getTotalFromTotals = (totals: Record<string, number>) =>
  Object.values(totals).reduce((sum, value) => sum + value, 0)

